import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=19f1fef4"
import script from "./manage.vue?vue&type=script&lang=ts"
export * from "./manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\sandy\\Desktop\\EIOSYS\\Admin\\Alembic-Grow-Admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19f1fef4')) {
      api.createRecord('19f1fef4', component.options)
    } else {
      api.reload('19f1fef4', component.options)
    }
    module.hot.accept("./manage.vue?vue&type=template&id=19f1fef4", function () {
      api.rerender('19f1fef4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/achievements/manage.vue"
export default component.exports